"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.event = exports.info = exports.ready = exports.warn = exports.error = exports.wait = exports.prefixes = exports.serverLogger = exports.clientLogger = void 0;
var chalk_1 = __importDefault(require("chalk"));
var clearConsole = function () {
    return Object.keys(console).reduce(function (acc, key) {
        var _a, _b;
        if (typeof console[key] === "function") {
            return __assign(__assign({}, acc), (_a = {}, _a[key] = function () { return null; }, _a));
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = console[key], _b));
    }, {});
};
exports.clientLogger = (function () {
    if (typeof window !== "undefined") {
        return console;
    }
    return clearConsole();
})();
exports.serverLogger = (function () {
    if (typeof window === "undefined") {
        return console;
    }
    return clearConsole();
})();
exports.prefixes = {
    wait: chalk_1["default"].cyan("wait") + "  -",
    error: chalk_1["default"].red("error") + " -",
    warn: chalk_1["default"].yellow("warn") + "  -",
    ready: chalk_1["default"].green("ready") + " -",
    info: chalk_1["default"].cyan("info") + "  -",
    event: chalk_1["default"].magenta("event") + " -"
};
function wait() {
    var message = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        message[_i] = arguments[_i];
    }
    console.log.apply(console, __spreadArray([exports.prefixes.wait], message, false));
}
exports.wait = wait;
function error() {
    var message = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        message[_i] = arguments[_i];
    }
    console.error.apply(console, __spreadArray([exports.prefixes.error], message, false));
}
exports.error = error;
function warn() {
    var message = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        message[_i] = arguments[_i];
    }
    console.warn.apply(console, __spreadArray([exports.prefixes.warn], message, false));
}
exports.warn = warn;
function ready() {
    var message = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        message[_i] = arguments[_i];
    }
    console.log.apply(console, __spreadArray([exports.prefixes.ready], message, false));
}
exports.ready = ready;
function info() {
    var message = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        message[_i] = arguments[_i];
    }
    console.log.apply(console, __spreadArray([exports.prefixes.info], message, false));
}
exports.info = info;
function event() {
    var message = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        message[_i] = arguments[_i];
    }
    console.log.apply(console, __spreadArray([exports.prefixes.event], message, false));
}
exports.event = event;
